import './index.css';
import React from 'react';
import App from './App';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { AuthProvider } from './context/AuthContext';
import { SnackbarProvider } from './context/SnackBarContext';
import { store } from './redux/store';
import { InventoryProvider } from './context/InventoryContext';
import { QrAuthProvider } from './context/QrAuth';
import { CrmProvider } from './context/CrmContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <CrmProvider>
        <InventoryProvider>
          <QrAuthProvider>
            <SnackbarProvider>
              <App />
            </SnackbarProvider>
          </QrAuthProvider>
        </InventoryProvider>
        </CrmProvider>
      </AuthProvider>
    </Provider>
  </React.StrictMode>
);
